import routerOptions0 from "/home/ploi/www.fara-kezmarok.sk/node_modules/.pnpm/nuxt@3.17.6_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@24.0.13_@vue+compiler-sfc@_umbmc3znpbmwgqzvrx6ixdkz5i/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}